import React, { Fragment, useMemo } from "react";

import SupUiLoading from "@/components/Ui/Loading";
import useTokenBalances from "@/hooks/api/useTokenBalances";
import { formatCurrencyCompact } from "@/utils";

export default function Web3TotalPortfolio() {
  const { data, isLoading, isError } = useTokenBalances(true, "fully-cached");

  const totalValue = useMemo(() => {
    return data?.reduce((acc, curr) => acc + parseFloat(curr.amountInFiat || "0"), 0);
  }, [data]);

  return (
    <Fragment>
      <h3 className="font-mono text-[16px] font-bold leading-[20px] tracking-[.5px]">Wallet value</h3>
      <div className="h-[48px] font-mono text-[48px] font-bold leading-none tracking-[.5px]">
        {totalValue !== undefined ? formatCurrencyCompact(totalValue, 3, 2) : isLoading ? <SupUiLoading isSmall /> : isError ? "Error fetching data ❌" : "Empty"}
      </div>
    </Fragment>
  );
}
